import React from 'react';
import { changeCdnUrl } from '../../utils/common.utils';
import BaseText from '../BaseText';
import { View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import RowView from '../RowView';
import Icon from '../Icon';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useDateFormat } from '../../utils/useDateFormat';
import { virtualPaymentType } from '../../constants/Enums';

const tripComponentIcon = {
  A: 'flight',
  H: 'hotel',
  C: 'car',
  R: 'rail',
};

const getTripComponents = (components) => {
  if (typeof components !== 'string') {
    return [];
  }
  return components.split(',').map((char) => tripComponentIcon[char]);
};

const MyTripsCard = ({ item, ...rest }) => {
  const { t } = useTranslation(i18nNS.myTrips);
  const { tKey } = useComponentTKey('MyTripsScreen');
  const formatDate = useDateFormat();
  const activeStyle = item.isOld ? null : styles.futureText;
  if (!item) {
    return null;
  }
  const easycardPurchaseIndicator = [
    virtualPaymentType.ConfermaAPIVP,
    virtualPaymentType.ConfermaSabreVP,
    virtualPaymentType.ConnexPayAPIVP,
  ].includes(item?.VirtualPaymentSource);
  const isAHCPresent = getTripComponents(item?.Tripcomponents)?.length === 3;
  const easycardSrc = item?.isOld
    ? require('../../assets/images/easycard-blue.png')
    : require('../../assets/images/easycard-white.png');
  return (
    <TouchableOpacity {...rest}>
      <RowView style={[styles.card, item.isOld ? null : styles.future]}>
        <Image style={styles.image} source={{ uri: changeCdnUrl(item.ImageURL) }} />
        <View style={styles.content}>
          <BaseText style={[styles.title, activeStyle]}>{item.TripName}</BaseText>
          <BaseText style={activeStyle}>
            {formatDate(item.StartDate, 'LL') + ' - ' + t(tKey(item.TripFilterType))}
          </BaseText>
          <View style={styles.viewStyle}>
            <View>
              <RowView>
                {getTripComponents(item.Tripcomponents).map((iconName, index) => (
                  <Icon key={index} style={[styles.icon, activeStyle]} name={iconName} />
                ))}
              </RowView>
            </View>
            <View>
              {easycardPurchaseIndicator && (
                <Image
                  style={
                    isAHCPresent
                      ? [styles.easycardIndicator, { left: 40 }]
                      : [styles.easycardIndicator, { left: 44 }]
                  }
                  source={easycardSrc}
                />
              )}
            </View>
          </View>
        </View>
        <View style={CommonStyles.p2}>
          <BaseText style={[styles.pnr, activeStyle]}>{item.Recordlocator}</BaseText>
        </View>
      </RowView>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  card: {
    ...CommonProperties.p2,
    ...CommonProperties.borderRadius,
  },
  future: {
    backgroundColor: Color.primary,
  },
  futureText: {
    color: Color.accent,
  },
  content: {
    flex: 1,
  },
  title: {
    ...CommonProperties.h3,
  },
  icon: {
    fontSize: 18,
    color: Color.primary,
    ...CommonProperties.mr3,
  },
  image: {
    width: scale(56),
    height: scale(56),
    borderRadius: scale(28),
    ...CommonProperties.mr3,
  },
  pnr: {
    color: Color.text.medium,
    ...CommonProperties.small,
  },
  easycardIndicator: {
    width: 60,
    height: 12,
    marginTop: 2,
    position: 'relative',
  },
  viewStyle: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

export default MyTripsCard;
